export const sameId = (left, right) => Number(left) === Number(right);

export const excludeIds = (ids, excluded) =>
  ids.filter((id) => !excluded.some((other) => sameId(id, other)));
